import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi'
import Container from './styles'

/**
 * Renders a Slider for a list of videos.
 *
 * @component
 * const obj = [{ embedId: @string , title: @string }]
 * return (
 *   <VideoSlider videos={obj} />
 * );
 */
function NextArrow(props) {
  const { onClick } = props
  return (
    <>
      <button type="button" className="arrow next" onClick={onClick}>
        <FiChevronRight />
      </button>
    </>
  )
}
function PrevArrow(props) {
  const { onClick } = props
  return (
    <>
      <button type="button" className="arrow prev" onClick={onClick}>
        <FiChevronLeft />
      </button>
    </>
  )
}

const VideoHeader = ({ videos }) => (
  <Container>
    <div>
      <Slider
        dots
        infinite
        speed={500}
        slidesToShow={1}
        slidesToScroll={1}
        nextArrow={<NextArrow />}
        prevArrow={<PrevArrow />}
      >
        {videos.map(video => (
          <div key={video.embedId}>
            <h3>{video.title}</h3>
            <iframe
              title={video.title}
              width="760"
              height="515"
              src={`https://www.youtube.com/embed/${video.embedId}`}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        ))}
      </Slider>
    </div>
  </Container>
)

export default VideoHeader
